export default __webpack_public_path__ + "static/media/icon-github-w.9b8eebf7.svg";